export default __webpack_public_path__ + "static/lowenfels-93a5b76d21f5caf888e9a65abb6c32d7.png";